export default "__VITE_ASSET__Bm9clieo__"